// extracted by mini-css-extract-plugin
export default {"backdrop":"LoadingSpinner_backdrop__46ae+","loading":"LoadingSpinner_loading__v1dg7","rotate":"LoadingSpinner_rotate__2KQ-D"};